import React, { useRef, useEffect, useState } from 'react';
import ReactJson from 'react-json-view'


const Text = (props) => {
  const [firstLoad, setFirstLoad] = useState(true);
  const [jsonData, setJsonData] = useState(null);
  let selectedAsset = window.elvisContext.activeTab.originalAssetSelection[0]




  const test = async () => {
    setFirstLoad(false)
    const searchResults = await window.assetsPluginContext.fetch(`/file/${selectedAsset.id}/*/${selectedAsset.filename}`, {
      method: 'get',
    });
    return searchResults

  }
  if (firstLoad) {
    test()
      .then(res => {
        console.log({ res })
        setJsonData(res)
      })
  }



  return (

    <div className="ems_content_workspace">
      <div className="ems_visual-wrapper">
        <div style={{ width: "60%" }}>
        <ReactJson src={jsonData}  />

          {/* {console.log(window.assetsPluginContext._context.activeTab.originalAssetSelection[0])} */}
        </div>

        {/* <img src={window.assetsPluginContext._context.activeTab.originalAssetSelection[0].previewUrl}/> */}

      </div>


    </div>
  );
};

export default Text;